import Vue from 'vue';

const templateMixin = Vue.extend({
  data: () => ({
    show: true,
  }),
  watch: {
    show(val: boolean) {
      setTimeout(() => {
        this.$emit(val ? 'open' : 'close');
      }, 500);
    },
  },
  methods: {
    close() {
      this.show = false;
    },
  },
});

export default templateMixin;
